import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class TaskCreatedEvent extends EventV2<{ entityType: EdsEntityCodes; entityKey: string }> {}
